import { NgModule } from '@angular/core';
import { DxDateBoxModule } from 'devextreme-angular';

const DEVEXTREME_MODULES: any[] = [DxDateBoxModule];

@NgModule({
  imports: [...DEVEXTREME_MODULES],
  exports: [...DEVEXTREME_MODULES],
})
export class DevExtremeModule {}
